import { render, staticRenderFns } from "./ModalDutyEdit.vue?vue&type=template&id=38077761&scoped=true"
import script from "./ModalDutyEdit.vue?vue&type=script&lang=js"
export * from "./ModalDutyEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalDutyEdit.vue?vue&type=style&index=0&id=38077761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38077761",
  null
  
)

export default component.exports